import { toast } from 'react-hot-toast';
import { showToast } from "./Utils";
export const handleToastMessage = (error) => {
    const errorResponse = error?.error?.data;
    
    // Handle case where error response is undefined or null
    if (!errorResponse) {
        showToast("Something went wrong. Please try again.", "error");
        return;
    }
    
    if (errorResponse?.message === "Validation errors" && errorResponse?.data) {
        const firstErrorKey = Object.keys(errorResponse?.data)[0]; // Get the first field
        const firstErrorMessage = errorResponse.data[firstErrorKey][0]; // Get the first error message
        showToast(firstErrorMessage, "error")
    } else if (errorResponse.message) {
        showToast(errorResponse.message, "error");
    } else {
        showToast("Something went wrong. Please try again.", "error");
    }
};

export const getAuthorizationHeader = () => {
    const authToken = localStorage.getItem("authToken");
    return {
        'Authorization': `Bearer ${authToken}` // Add "Bearer " prefix
    };
};
export const handleQueryError = async (queryFulfilled: Promise<any>) => {
    queryFulfilled.catch(error => {
        handleToastMessage(error) // Provide a fallback message
    });
};



export const handleQueryErrorAndSuccess = async (
    queryFulfilled: Promise<any>,
    action: 'Created' | 'Updated' | 'Deleted' | 'Reset' | 'Assigned' | any,
    entityName: string
) => {
    queryFulfilled.then((res) => {
        const message = res?.data?.message;
        // console.log(res?.data)
        showToast(`${message}`, "success");
        // showToast(`${entityName} ${action.toLowerCase()} successfully.`, "success");
    }).catch(error => {
        handleToastMessage(error); // Provide a fallback message
    });
};


